import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import assign from 'object-assign';
import notify from '../../shared/feedback/notifications';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import IPlanFirm from './IPlanFirm';
import * as Actions from './Actions';
import PlanFirmForm from './PlanFirmForm';

export class PlanFirmModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            input: assign({}, this.props.emptyInput),
            creating: false
        };

        this.onFormInputChange = this.onFormInputChange.bind(this);
        this.save = this.save.bind(this);
        this.create = this.create.bind(this);
        this.update = this.update.bind(this);
    }

    UNSAFE_componentWillMount(): void {
        if (this.props.editId > 0) {
            this.props.actions
                .edit(this.props.editId)
                .then(() => {
                    this.setState({
                        input: assign({}, this.props.edit)
                    });
                })
                .catch((error: any) => handleError(error));
        }
    }

    onFormInputChange(e: any): void {
        let input = this.state.input;
        const value = e.target.value;

        input[e.target.name] = value;

        this.setState({ input: assign({}, input) });
    }

    save(): void {
        this.setState({ creating: true });
        if (this.props.editId > 0) {
            this.update();
        } else {
            this.create();
        }
    }

    create(): void {
        this.props.actions
            .create(this.state.input.name)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('plan-firms/notification/plan-firm-added'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update(): void {
        this.props.actions
            .update(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('plan-firms/notification/plan-firm-updated'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    render(): any {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.editId > 0
                                ? Translate('plan-firms/modal/title/edit-plan-firm')
                                : Translate('plan-firms/modal/title/add-plan-firm')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PlanFirmForm
                            name={this.state.input.name}
                            onChange={this.onFormInputChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('plan-firms/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.save}
                        >
                            {Translate('plan-firms/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        emptyInput: { id: -1, name: '' },
        edit: state.planFirms.edit
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            new: () => dispatch(Actions.list()),
            create: (name: string) => dispatch(Actions.create(name)),
            edit: (id: number) => dispatch(Actions.edit(id)),
            update: (input: IPlanFirm) => dispatch(Actions.update(input))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanFirmModal);
